<template>
  <div class="feedback_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span
                >客户反馈
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="feed_box">
        <section class="w3l-contact-1 py-5" id="contact">
          <div class="contacts-9 py-lg-5 py-md-4">
            <div class="container">
              <div class="d-grid contact-view mb-5 pb-lg-5">
                <div class="cont-details">
                  <div class="contactct-fm-text text-left mb-md-5 mb-4">
                    <!-- <div class="header-title mb-md-5 mt-4">
                      <span class="sub-title">联系我们</span>
                    </div> -->
                    <!-- <p class="mb-sm-5 mb-4">
                      Start working with Us that can provide everything you need
                      to generate awareness, drive traffic, connect. <br />
                      We guarantee that you’ll be able to have any issue
                      resolved within 24 hours.
                    </p> -->
                  </div>
                  <div class="cont-top">
                    <div class="cont-left text-center">
                      <span class="fa fa-phone"></span>
                    </div>
                    <div class="cont-right">
                      <h6>联系电话</h6>
                      <p>
                        <span>{{companyInfo.companyPhone}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="cont-top margin-up">
                    <div class="cont-left text-center">
                      <span class="fa fa-envelope-o"></span>
                    </div>
                    <div class="cont-right">
                      <h6>联系邮箱</h6>
                      <p>
                        <span class="mail">{{companyInfo.companyEmail}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="cont-top margin-up">
                    <div class="cont-left text-center">
                      <span class="fa fa-map-marker"></span>
                    </div>
                    <div class="cont-right">
                      <h6>联系地址</h6>
                      <p class="pr-lg-5">{{companyInfo.companyAddress}}</p>
                    </div>
                  </div>
                  <div>
              <baidu-map :center="center" :zoom="zoom" @ready="handler" style="width:230px;height:240px;float:left;margin-top:5px;" @click="getClickInfo" :scroll-wheel-zoom='true'>
    </baidu-map>
    <baidu-map :center="centerhz" :zoom="zoomhz" @ready="handlerhz" style="width:230px;height:240px;float:left;margin-top:5px;margin-left:5px" @click="getClickInfo" :scroll-wheel-zoom='true'>
    </baidu-map>

            </div>
                </div>
                <div class="map-content-9">
                  <div class="contactct-fm map-content-9 pl-lg-4">
                    <div class="contactct-fm-text text-left">
                      <div class="header-title mb-md-5 mt-4">
                        <span class="sub-title">留言板</span>
                      </div>
                      <p class="mb-sm-5 mb-4">您的支持是我们最的动力</p>
                    </div>
                    <div>

                      <el-form ref="form" :model="form" label-width="80px">
                        <div class="twice-two">
                        <el-input
                          v-model="form.username"
                          placeholder="您的姓名"
                        ></el-input>
                        <el-input
                          v-model="form.userEmail"
                          placeholder="您的邮箱"
                        ></el-input>
                      </div>
                      <div class="twice">
                        <el-input
                          v-model="form.userIpthone"
                          placeholder="您的联系电话"
                        ></el-input>
                      </div>
                      <div class="twice">
                        <el-input v-model="form.title" placeholder="标题"></el-input>
                      </div>

                      <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="想对我们说的话..."
                        v-model="form.message"
                      >
                      </el-input>

                      </el-form>
                    
                      <div class="text-right">
                        <button
                          type="submit"
                          class="btn btn-primary btn-style mt-4"
                          @click="addfeedback"
                        >
                          提交
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";
import {addFeedback} from "@/api/feedback/index"
import { bannerList } from "@/api/menu/index.js";
import { listCompanyInfo } from "@/api/companyInfo/companyInfo.js";
export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      backgroundImg: "",
      form: {},
      imgqueryParams: {
       picType:"feedback"
      },
      queryParams: {
        pageNum: 1,
        pageSize: 1,
      },
      companyInfo:{},
      center: {lng: 113.518628, lat: 22.567248},
      zoom: 13,
      centerhz: {lng: 113.518628, lat: 22.567248},
      zoomhz: 13
    };
  },
  mounted(){
    this.getBannerList();
    this.getCompanyInfo();
  },
  methods:{



    handler ({BMap, map}) {
      var opts = {
    position: new BMap.Point(113.522595, 22.564164), // 指定文本标注所在的地理位置
    offset: new BMap.Size(10, -30) // 设置文本偏移量
};
      var label = new BMap.Label('广东金城金素制药有限公司', opts);
      label.setStyle({
    color: 'blue',
    borderRadius: '5px',
    borderColor: '#ccc',
    fontSize: '14px',
    height: '30px',
    lineHeight: '30px',
    fontFamily: '微软雅黑'
});
      
      var point = new BMap.Point(113.523476, 22.564256)
      map.centerAndZoom(point, 13)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {strokeColor: 'Red', strokeWeight: 20, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      map.addOverlay(circle)
      map.addOverlay(label)
    },
    getClickInfo (e) {
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    },
//杭州
    handlerhz ({BMap, map}) {
      var opts = {
    position: new BMap.Point(120.167388, 30.190432), // 指定文本标注所在的地理位置
    offset: new BMap.Size(10, -30) // 设置文本偏移量
};
      var label = new BMap.Label('杭州金城制剂管理中心', opts);
      label.setStyle({
    color: 'blue',
    borderRadius: '5px',
    borderColor: '#ccc',
    fontSize: '14px',
    height: '30px',
    lineHeight: '30px',
    fontFamily: '微软雅黑'
});
      
      var point = new BMap.Point(120.167388, 30.190432)
      map.centerAndZoom(point, 15)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var circle = new BMap.Circle(point, 13, {strokeColor: 'Red', strokeWeight: 20, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      map.addOverlay(circle)
      map.addOverlay(label)
    },

    



    getCompanyInfo(){
        listCompanyInfo(this.queryParams).then(res =>{
            this.companyInfo = res.rows[0]
        })
    },

    getBannerList(){
      bannerList(this.imgqueryParams).then(res =>{
        if(res.total > 0){
          this.backgroundImg = res.rows[0].picUrl
        }
        
      })
    },
    addfeedback(){
      addFeedback(this.form).then(res =>{
        if(res.code == 200){
          this.form = {}
          this.$message({
          message: '提交成功。非常感谢您的反馈',
          type: 'success'
        });
        }
      })
    }
  }
};
</script>

<style>
</style>